import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Video'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z"
          fill="#FFD6B0"
        />
        <path
          d="M17.125 26.6939V23.2312"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.125 26.6938V23.1938"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.125 23.1938L17.125 23.2312V11.8188H31.125V23.1938V23.1938Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.5438 26.6938H16.7062L15.2315 28.2012C14.9044 28.5386 14.807 29.0371 14.983 29.4729C15.1543 29.9039 15.5691 30.1888 16.033 30.1939H32.2123C32.6762 30.1888 33.091 29.9039 33.2623 29.4729C33.4384 29.0371 33.341 28.5386 33.0138 28.2012L31.5438 26.6938Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9923 28.5605L13.1174 20.5688"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.9624 28.144L35.1721 20.5688"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.125 20.5688H11"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.125 20.5688H37.25"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.334 30.1938L18 37.1938"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 30.1938L30.25 37.1938"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8389 15.1429C23.8937 15.0354 24.0041 14.9678 24.1247 14.9678C24.2453 14.9678 24.3558 15.0354 24.4106 15.1429L25.0732 16.4811C25.1197 16.5744 25.2091 16.639 25.3124 16.6537L26.8011 16.8684C26.9193 16.8856 27.018 16.9676 27.0566 17.0807C27.0946 17.1938 27.0642 17.3186 26.9784 17.4016L25.8969 18.4516C25.8232 18.5228 25.7895 18.6259 25.8071 18.7269L26.0614 20.2039C26.0813 20.3221 26.0319 20.4413 25.9342 20.5107C25.8357 20.5805 25.7063 20.5891 25.5994 20.5329L24.2741 19.8387C24.1805 19.7898 24.0689 19.7898 23.9754 19.8387L22.6501 20.5317C22.5432 20.5879 22.4138 20.5794 22.3152 20.5096C22.2175 20.4401 22.1681 20.3209 22.1881 20.2027L22.4424 18.7304C22.4599 18.6294 22.4263 18.5263 22.3526 18.4551L21.2711 17.4051C21.1853 17.3221 21.1549 17.1973 21.1929 17.0842C21.2289 16.9679 21.3281 16.8824 21.4484 16.8637L22.9371 16.6491C23.0403 16.6343 23.1297 16.5698 23.1762 16.4764L23.8389 15.1429Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
